import { Call } from '../Call';
import { HttpResponse } from '../HttpResponse';
import { HttpRequest } from '../HttpRequest';
import { ResponseAdapter } from './ResponseAdapter';

/**
 * Creates a new request, process the response as typed value and returns the promise
 * of typed response or error.
 */
export class CallAdapter<RequestBody, ResponseBody> implements Call<RequestBody, ResponseBody> {
  request!: HttpRequest<RequestBody>;
  response?: HttpResponse<ResponseBody> | undefined;

  /**
   *
   * Executes the request, processes the response as typed value and returns the promise
   * of typed response or error.
   *
   * @method Method execute
   *
   * @param requestUrl Accepts the request url with full path and query parameter.
   *
   * @param fetchOptions Various options such as Headers, Request payload,
   * Method name - [{@link Method}], Signal (abort)can be provided.
   *
   * @returns  Returns a promise of typed response or error. [{@link HttpResponse}]
   *
   */
  execute(requestUrl: string, fetchOptions: RequestInit): Promise<HttpResponse<ResponseBody>> {
    return this.send_(requestUrl, fetchOptions);
  }

  private send_ = async (requestUrl: string, fetchOptions: RequestInit): Promise<HttpResponse<ResponseBody>> => {
    try {
      // Note: Window.fetch does not allow fetch options for get request. Where as the same works fine with node fetch.
      const response = await fetch(requestUrl.toString(), fetchOptions);

      const internalResponse = new ResponseAdapter<ResponseBody>(response, requestUrl);
      await internalResponse.resolveBody(this.request.responseType);
      this.response = internalResponse;
      return Promise.resolve(this.response);
    } catch (error) {
      // Todo: Handle errors.
      return Promise.reject(error);
    }
  };
}
